export default "__VITE_ASSET__Dp4XQ1_S__"